import * as Yup from 'yup';

const validKnowblerFileTypes = ['image/png', 'image/jpeg', 'image/jpg'];
const validSearchUnifyFileTypes = ['image/svg+xml', 'image/png', 'image/svg'];

const schema = Yup.object().shape({
    title: Yup.string().required('Required').trim().min(1, 'Title cannot be empty'),
    description: Yup.string().required('Required').trim().min(1, 'Description cannot be empty'),
    product: Yup.number().required('Required').min(1, 'Required'),
    error: Yup.number(),
    fileType: Yup.string(),
    thumbnailUrl: Yup.string().test(
        'is-required-when-product-1-and-videoUrl-not-empty',
        // eslint-disable-next-line func-names
        function () {
            const { product, error, fileType } = this.parent;


            if (error === 1 && fileType) {
                return this.createError({ path: 'thumbnailUrl', message: 'Wrong File Format' });
            }

            if(product === 1 && fileType && !validSearchUnifyFileTypes.includes(fileType)) {
                return this.createError({ path: 'thumbnailUrl', message: 'Searchunify only supports png or svg file format' });
            }

            if(product === 2 && fileType && !validKnowblerFileTypes.includes(fileType)) {
                return this.createError({ path: 'thumbnailUrl', message: 'Knowbler only supports png, jpg or jpeg file format' });
            }
            
            return true;
        }
    ),
    videoUrl: Yup
        .string()
        .optional()
        .matches(
            /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/,
            'Enter a valid video URL.'
        ),
    redirectionUrl: Yup
        .string()
        .matches(
            /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/,
            'Enter a valid redirection URL.'
        ),
    clients: Yup.array().required('Required').min(1, 'Required'),
    sendEmail: Yup.boolean(),
    emailBody: Yup.string().when('sendEmail', {
        is: true,
        then: (schema) => schema.required('Email body is required when Send Email is checked').trim().min(1, 'Email body cannot be empty'),
        otherwise: (schema) => schema.notRequired(),
    }),
    bannerEnabled: Yup.boolean(),

});

export default schema;